module.exports = __webpack_public_path__ + "img/scene3-4.91482cf4.png";